import React, { FC, ReactElement, useEffect, useState } from 'react';
import { connect } from 'react-redux';
// Components
import Space from '../../../components/layout/space';
import EditReservationWrapper from './editReservationWrapper';
import EditSelect from '../../../components/profile/editSelect';
import MeetingPointMap from '../../../components/map/meetingPointMap';
import { PropsFromModal } from '../../../components/modals/createModalHOC';
// Hooks
import { useUpdateRide } from '../../../core/services/rides';
// Resources
import { findStop } from '../../../utils/business';
import { stringsRes } from '../../../resources/strings';
import { EditRideInput, MeetingPoint, PickerOption, Ride, StopType } from '../../../core/apiTypes';

interface EditReservationMeetingPointProps extends PropsFromModal {
    reservation: Ride;
}

const EditReservationMeetingPoint: FC = (props: EditReservationMeetingPointProps): ReactElement => {
    const { reservation, onRequestClose } = props;

    const [listMeetingPoint, setListMeetingPoint] = useState<MeetingPoint[]>(null);
    const [meetingPoint, setMeetingPoint] = useState<MeetingPoint>(null);

    const updateRide = useUpdateRide();
    // const { id } = useParams();
    // const { data: reservation } = useGetReservation<Ride>({
    //     enabled: !!id,
    //     variables: { id },
    // });

    useEffect(() => {
        if (reservation) {
            const pickup = findStop(reservation.stops, StopType.PICKUP);
            if (pickup) {
                const meetingPoints = reservation.nameboard_option
                    ? pickup.address?.meeting_points_nameBoard
                    : pickup.address?.meeting_points;

                setListMeetingPoint(meetingPoints);
                setMeetingPoint(meetingPoints?.find((mp) => String(mp.id) === String(pickup?.meeting_point_id)));
            }
        }
    }, [reservation]);

    const onChangeMeetingPoint = (meeting: string): void => {
        const newMeetingPoint: MeetingPoint = listMeetingPoint.find((mp) => String(mp.id) === meeting);
        if (newMeetingPoint) {
            setMeetingPoint(newMeetingPoint);
        } else {
            setMeetingPoint(null);
        }
    };

    const onConfirm = (): void => {
        const payload: EditRideInput = {
            id: reservation.id,
            meeting_point_id: meetingPoint.id,
        };

        updateRide.mutate(payload, {
            onSuccess: () => {
                onRequestClose();
            },
        });
    };

    const meetingPointOptions = (): PickerOption[] => {
        const res = [];
        if (listMeetingPoint?.length > 0) {
            listMeetingPoint.forEach((mp) => res.push({ value: `${mp.id}`, label: mp.name }));
            // listMeetingPoint.forEach((mp) => res.push({ value: `${mp.id}`, label: `${mp.name} - ${mp.rdv_point}` }));
        }
        return res;
    };

    return (
        <EditReservationWrapper
            {...props}
            onConfirm={onConfirm}
            loadingConfirm={updateRide.isLoading}
            disableConfirm={!meetingPoint}
        >
            <EditSelect
                noTitle
                title={stringsRes.booking.meetingPointName}
                items={meetingPointOptions()}
                initialValue={meetingPoint?.id}
                onSelect={onChangeMeetingPoint}
            />
            <Space value={4} />
            <MeetingPointMap meetingPoint={meetingPoint} />
        </EditReservationWrapper>
    );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
    // prefillRide: currentBookingActions.prefillRide,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditReservationMeetingPoint);
